import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import BookNow from './components/BookNow';
import DiscoveryCall from './components/DiscoveryCall';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book-now" element={<BookNow />} />
          <Route path="/discovery-call" element={<DiscoveryCall />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
